import { render, staticRenderFns } from "./SelectStrategiesModal.vue?vue&type=template&id=8405e128&scoped=true&"
import script from "./SelectStrategiesModal.vue?vue&type=script&lang=js&"
export * from "./SelectStrategiesModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectStrategiesModal.vue?vue&type=style&index=0&id=8405e128&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8405e128",
  null
  
)

export default component.exports